import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../services/IFilter";

export class ContactDepartmentFilter implements IFilter {
  anyChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  nameChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name(): any {
    return this.nameChange.value;
  }
  set name(name: any) {
    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  companyIdChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId(): any {
    return this.companyIdChange.value;
  }
  set companyId(companyId: any) {
    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  contactCompanyIdChange: BehaviorSubject<any> = new BehaviorSubject<any>('');
  get contactCompanyId(): any {
    return this.contactCompanyIdChange.value;
  }
  set contactCompanyId(contactCompanyId: any) {
    this.contactCompanyIdChange.next(contactCompanyId);
    this.emitChange("contactCompanyId", contactCompanyId);
  }

  emitChange(prop: string, value: any): void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams(): HttpParams {
    let params: HttpParams = new HttpParams();

    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.contactCompanyId && this.contactCompanyId !== '') {
      params = params.set("contactCompanyId", this.contactCompanyId);
    }

    return params;
  }

  setFilters(props: any): void {
    this.contactCompanyIdChange.next(props.contactCompanyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.companyIdChange.next(props.companyId || undefined);
  }

  toObj() {
    return {
      contactCompanyId: this.contactCompanyId,
      companyId: this.companyId,
      name: this.name
    };
  }

  clear(): void {
    this.name = undefined;
    this.contactCompanyId = undefined;
    this.companyId = undefined;
  }
}
